import React, { useEffect } from "react";

import styles from '../Form.module.css'

import MultiSelect from "../inputs/MultiSelect";
import RadioSelect from "../inputs/RadioSelect";
import { BsFillCheckCircleFill } from 'react-icons/bs'


function Step1({ formData, setFormData, setNextButtonState }) {




  useEffect(() => {

    setNextButtonState(
      formData.ageInterval !== '' &&
      formData.grade !== '' &&
      formData.mostEnjoyableMaterial !== '' &&
      formData.leastEnjoyableMaterial !== '')
  }, [formData]);


  return (
    <div>
      <div className={styles.header}>
        <h1>Profile Set Up</h1>
      </div>
      <div className={styles.subFormContainer}>


        <div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.ageInterval === '' ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              What is your age range?
            </div>

            <RadioSelect

              onChange={(data) =>
                setFormData({ ...formData, ageInterval: data })
              }

              value={formData.ageInterval}
              options={[
                { value: '6-8', component: <div>6-8</div> },
                { value: '9-11', component: <div>9-11</div> },
                { value: '12-14', component: <div>12-14</div> },
                { value: '15-17', component: <div>15-17</div> },]}

              selectedStyle={{ backgroundColor: "rgb(0, 123, 250)", color: 'white' }}
              notSelectedStyle={{ backgroundColor: "rgb(0, 123, 250,0.06)", color: "rgb(0, 123, 250)" }}
            />
          </div>

        </div>
        <div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.grade === '' ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              Select your Grade
            </div>
            <select
              value={formData.grade}
              onChange={(event) => setFormData({ ...formData, grade: event.target.value })
              }>

              <option value="" disabled hidden> Select Grade:</option>
              <option value="Grade 1">Grade 1 - EB1</option>
              <option value="Grade 2">Grade 2 - EB2</option>
              <option value="Grade 3">Grade 3 - EB3</option>
              <option value="Grade 4">Grade 4 - EB4</option>
              <option value="Grade 5">Grade 5 - EB5</option>
              <option value="Grade 6">Grade 6 - EB6</option>
              <option value="Grade 7">Grade 7 - EB7</option>
              <option value="Grade 8">Grade 8 - EB8</option>
              <option value="Grade 9">Grade 9 - EB9</option>
              <option value="Grade 10">Grade 10 - S1</option>
              <option value="Grade 11 -S2S">Grade 11 Science - S2S</option>
              <option value="Grade 11 -S2E">Grade 11 Economics - S2E</option>
              <option value="Grade 12 -SG">Grade 12 General Science - SG</option>
              <option value="Grade 12 -SV">Grade 12 Life Science - SV</option>
              <option value="Grade 12 -SE">Grade 12 Economy/Sociology - SE</option>
              <option value="Grade 12 -LH">Grade 12 Humanity/Litterature - LH</option>
            </select>
          </div>
        </div>






        <div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.leastEnjoyableMaterial === '' ? 'transparent' : 'rgb(0, 123, 250)' }}
          ><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              Which subject do you enjoy the least?
            </div>

            <select

              value={formData.leastEnjoyableMaterial}
              onChange={(event) => setFormData({ ...formData, leastEnjoyableMaterial: event.target.value })
              }>

              <option value="" disabled hidden> Select Materials:</option>
              <option value="Math">Math</option>
              <option value="Arabic">Arabic</option>
              <option value="French">French</option>
              <option value="English">English</option>
              <option value="Economy">Economy</option>
              <option value="Sociology">Sociology</option>

              <option value="Philosophy">Philosophy</option>
              <option value="Physics">Physics</option>
              <option value="Chemistry">Chemistry</option>
              <option value="Biology">Biology</option>
              <option value="History">History</option>
              <option value="Geography">Geography</option>
              <option value="Civics">Civics</option>
              <option value="Informatics">Informatics</option>





            </select>

          </div>
        </div>




        <div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.mostEnjoyableMaterial === '' ? 'transparent' : 'rgb(0, 123, 250)' }}
          ><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              Which subject do you enjoy the most?
            </div>

            <select

              value={formData.mostEnjoyableMaterial}
              onChange={(event) => setFormData({ ...formData, mostEnjoyableMaterial: event.target.value })
              }>

              <option value="" disabled hidden> Select Materials:</option>
              <option value="Math">Math</option>
              <option value="Arabic">Arabic</option>
              <option value="French">French</option>
              <option value="English">English</option>
              <option value="Economy">Economy</option>
              <option value="Sociology">Sociology</option>

              <option value="Philosophy">Philosophy</option>
              <option value="Physics">Physics</option>
              <option value="Chemistry">Chemistry</option>
              <option value="Biology">Biology</option>
              <option value="History">History</option>
              <option value="Geography">Geography</option>
              <option value="Civics">Civics</option>
              <option value="Informatics">Informatics</option>





            </select>

          </div>
        </div>



      </div>
    </div>
  );
}

export default Step1;
